import React from "react";
import PdFFileSelfProduction from "../../PdfFFileSelfProduction/index";
import SimulatorVPL from "../SimulatorVPL";
import { TIRPaybackTable } from "../../SimulatorTable/TIRPaybackTable";
import { EconomyCards } from "./EconomyCards";
import { BessSection } from "./bess/BessSection";
import { SimulatorTable } from "./SimulatorTable";
import { PdfDownloadButton } from "../PdfDownloadButton";
import { buildPdfDocument, PdfDocumentParams } from "../pdfDocuments";
import { getPdfDownloadActions } from "../pdfDownloadActions";
import { EconomyCompareResult, FormValues, SimulationType } from "../types";

interface SimulationResultsProps {
  values: FormValues;
  simulationResult: EconomyCompareResult | null;
  simulacaoSelected: string;
  construindoUsina: boolean;
  fortlev?: boolean;
  pdfDocumentParams: PdfDocumentParams;
  fileName: string;
  fileNamePresentation: string;
  fileProposalName: string;
  screenShotChart: string;
  proposalData: any;
  proposalPermission: boolean;
}

export const SimulationResults = ({
  values,
  simulationResult,
  simulacaoSelected,
  construindoUsina,
  fortlev,
  pdfDocumentParams,
  fileName,
  fileNamePresentation,
  fileProposalName,
  screenShotChart,
  proposalData,
  proposalPermission,
}: SimulationResultsProps) => (
  <>
    <div id="simulation-section" className="table-tarifa-container">
      {simulacaoSelected !== "" && simulationResult && (
        <>
          <div className="simulacao-header-title">
            <h1>Economia mensal</h1>
            <h2>
              Veja a projeção de economia mensal para o ano inicial de{" "}
              {values.initialYear} (reajuste das tarifas e preço de energia
              atualizado conforme definido)
            </h2>
          </div>

          <SimulatorTable
            simulationResult={simulationResult}
            simulationType={simulacaoSelected as SimulationType}
          />

          {simulationResult.bess && (
            <BessSection bess={simulationResult.bess} values={values} />
          )}
        </>
      )}

      {(simulationResult?.economyData?.length ?? 0) > 0 &&
        simulacaoSelected !== "" && (
          <>
            <div className="simulacao-header-title">
              <h1>Economia anual</h1>
              <h2>
                Veja a projeção de economia anual com o reajuste das tarifas e
                com o preço de energia atualizada para os próximos anos
              </h2>
            </div>

            <EconomyCards
              economyData={simulationResult!.economyData}
              simulationType={simulacaoSelected as SimulationType}
              quantidadeAnos={values.quantidadeAnos}
            />

            {construindoUsina ? (
              <>
                <div className="simulacao-header-title">
                  <h1>Projeções autoprodutor</h1>
                  <h2>
                    Veja a projeção de payback do projeto e o gráfico com o
                    fluxo de caixa anual, utilizando o valor presente, com os
                    reajustes de IPCA e conexão inclusos
                  </h2>
                </div>
              </>
            ) : (
              <>
                <div className="simulacao-header-title">
                  <h1>Projeções</h1>
                  <h2>
                    Gráfico com as economias acumuladas de cada ano, já com os
                    reajustes de IPCA e conexão
                  </h2>
                </div>
              </>
            )}

            {(construindoUsina || values.isBateria) && (
              <div className="resultadoSimulacaoContainer">
                <TIRPaybackTable
                  tir={simulationResult!.tir}
                  paybackAnual={simulationResult!.payBackAnual}
                  construindoUsina={construindoUsina}
                  construindoBateria={values.isBateria}
                  vplAnual={simulationResult!.vplAnual}
                />
              </div>
            )}

            <div className="simulator-vpl">
              <SimulatorVPL
                data={simulationResult!}
                construindoUsina={construindoUsina}
                construindoBateria={values.isBateria}
                accumulated={simulacaoSelected === "ML" && !values.isBateria}
              />
            </div>
          </>
        )}
    </div>

    {simulacaoSelected !== "" && simulationResult && (
      <div className="pdf-download-actions">
        {getPdfDownloadActions(
          simulacaoSelected as SimulationType,
          fortlev
        ).map((action) => {
          const document = buildPdfDocument(action.key, pdfDocumentParams);
          const downloadFileName =
            action.key === "presentation" ? fileNamePresentation : fileName;

          if (!document) return null;

          return (
            <PdfDownloadButton
              key={action.key}
              label={action.label}
              tooltip={action.tooltip}
              document={document}
              fileName={downloadFileName}
              actionKey={action.key}
              fortlev={fortlev}
            />
          );
        })}

        {screenShotChart !== "" &&
          proposalPermission &&
          proposalData &&
          (simulacaoSelected === "APE" || simulacaoSelected === "MLXAPE") &&
          values.generateProposal && (
            <PdfDownloadButton
              label="GERAR PROPOSTA EM PDF"
              tooltip="Baixa a proposta comercial de autoprodução com os dados da simulação."
              document={
                <PdFFileSelfProduction
                  proposalData={proposalData}
                  economyData={simulationResult}
                  screenShotChart={screenShotChart}
                  simulacaoSelected={simulacaoSelected}
                  cativoLivreData={simulationResult.firstSimulation}
                  apeData={simulationResult.secondSimulation}
                />
              }
              fileName={fileProposalName}
              actionKey="proposal"
              fortlev={fortlev}
            />
          )}
      </div>
    )}
  </>
);
